/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ControlFunctionDTO} from './ControlFunctionDTO';

/**
 * The OperationalScopeGetResponseDTO model module.
 * @module model/OperationalScopeGetResponseDTO
 * @version v0
 */
export class OperationalScopeGetResponseDTO {
  /**
   * Constructs a new <code>OperationalScopeGetResponseDTO</code>.
   * @alias module:model/OperationalScopeGetResponseDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OperationalScopeGetResponseDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OperationalScopeGetResponseDTO} obj Optional instance to populate.
   * @return {module:model/OperationalScopeGetResponseDTO} The populated <code>OperationalScopeGetResponseDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OperationalScopeGetResponseDTO();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
      if (data.hasOwnProperty('controlFunctions'))
        obj.controlFunctions = ApiClient.convertToType(data['controlFunctions'], [ControlFunctionDTO]);
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
OperationalScopeGetResponseDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
OperationalScopeGetResponseDTO.prototype.active = undefined;

/**
 * @member {Array.<module:model/ControlFunctionDTO>} controlFunctions
 */
OperationalScopeGetResponseDTO.prototype.controlFunctions = undefined;

/**
 * @member {String} tooltip
 */
 OperationalScopeGetResponseDTO.prototype.tooltip = undefined;

